import { background, brandPrimaryHover, brandSecondary, destructive, titles } from '../../../web/styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	card: {
		background: '#FFF',
		borderRadius: 3,
		boxShadow: '0px 2px 6px rgba(139, 139, 139, 0.2)',
		margin: '0 auto',
		maxWidth: '90vw',
		minHeight: 223,
		padding: '20px 28px',
		position: 'relative',
		top: '50%',
		transform: 'translateY(-50%)',
		width: 502,
	},
	container: {
		background,
		height: '100vh',
		width: '100vw',
	},
	error: {
		color: destructive,
		fontSize: 14,
		fontWeight: 'bold',
		marginBottom: 20,
	},
	paragraph: {
		color: titles,
		fontSize: 14,
		lineHeight: '20px',
		margin: '10px 0',
		marginBottom: 20,
	},
	resubscribeButton: {
		margin: '0 auto',
	},
	title: {
		color: brandPrimaryHover,
		fontSize: 18,
		fontWeight: 'bold',
		marginBottom: 20,
	},
	token: {
		background: '#F3F3F3',
		border: `1px dashed ${brandSecondary}`,
		borderRadius: 3,
		boxSizing: 'border-box',
		fontWeight: 'bold',
		margin: '0 0 0 3px',
		padding: '1px 5px',
	},
	unsubscribeContainer: {
		marginTop: 40,
		position: 'relative',
		textAlign: 'center',
	},
	unsubscribedTitle: {
		textAlign: 'center',
	},
});
